module.exports = __webpack_public_path__ + "img/slide_l.49645c44.svg";